import { createFileRoute } from '@tanstack/react-router';
import { SandboxPage } from '../sandbox-page';

export const Route = createFileRoute('/sandboxes/$sandboxId')({
  component: () => <SandboxPage sandboxId={Route.useParams().sandboxId} />,
});
